/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Action_PudosInputs */

const en_colleague_action_pudos = /** @type {(inputs: Colleague_Action_PudosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PUDO depots`)
};

const ja_colleague_action_pudos = /** @type {(inputs: Colleague_Action_PudosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PUDO 拠点`)
};

const fr_colleague_action_pudos = /** @type {(inputs: Colleague_Action_PudosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dépôts PUDO`)
};

const de_colleague_action_pudos = /** @type {(inputs: Colleague_Action_PudosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PUDO-Depots`)
};

/**
* | output |
* | --- |
* | "PUDO depots" |
*
* @param {Colleague_Action_PudosInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_action_pudos = /** @type {((inputs?: Colleague_Action_PudosInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Action_PudosInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_action_pudos(inputs)
	if (locale === "ja") return ja_colleague_action_pudos(inputs)
	if (locale === "fr") return fr_colleague_action_pudos(inputs)
	return de_colleague_action_pudos(inputs)
});